module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticClass: "relatorios-comparativos-container",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticClass: "equal-heights px-5 pb-5 pt-5 comparativo-row",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "comparativo-col",
    attrs: {
      "xs12": "",
      "md6": "",
      "id": "printStatus"
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3 mr-4"
  }, [_c('div', {
    staticClass: "comparativo-titulo"
  }, [_c('strong', [_vm._v("Status")])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative",
      "height": "calc(100% - 52px)"
    }
  }, [_c('div', {
    staticClass: "print-title"
  }, [_c('strong', [_vm._v("Status")]), _vm._v(" "), _c('small', [_vm._v("Relatório gerado em " + _vm._s(_vm.data))])]), _vm._v(" "), _c('div', {
    staticClass: "graph-legend"
  }, [_c('div', {
    staticClass: "legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legendChart.status)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "graph-container"
  }, [(_vm.dataLoaded) ? _c('PieChart', {
    attrs: {
      "chartdata": _vm.dataChart.status
    },
    on: {
      "generated": function($event) {
        _vm.setLegend($event, 'status')
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataLoaded) ? _c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": _vm.gerandoPdf
    },
    nativeOn: {
      "click": function($event) {
        _vm.printGraph('printStatus', 'Status')
      }
    }
  }, [_vm._v("Baixar relatório")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "comparativo-col",
    attrs: {
      "xs12": "",
      "md6": "",
      "id": "printSubstatus"
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3 ml-4"
  }, [_c('div', {
    staticClass: "comparativo-titulo"
  }, [_c('strong', [_vm._v("Sub-status")]), _vm._v(" "), (_vm.dataLoaded) ? _c('ul', {
    staticClass: "opcoes"
  }, _vm._l((Object.keys(_vm.dataChart.substatus)), function(substatus) {
    return _c('li', {
      class: {
        'ativo': _vm.substatusSelecionado === substatus
      },
      on: {
        "click": function($event) {
          _vm.changeSubstatusSelecionado(substatus)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(substatus))])])
  })) : _vm._e()]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative",
      "height": "calc(100% - 52px)"
    }
  }, [_c('div', {
    staticClass: "print-title"
  }, [_c('strong', [_vm._v("Sub-status")]), _vm._v(" "), _c('small', [_vm._v("Relatório gerado em " + _vm._s(_vm.data))])]), _vm._v(" "), _vm._l((Object.keys(_vm.dataChart.substatus)), function(substatus) {
    return (_vm.dataLoaded) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.substatusSelecionado === substatus),
        expression: "substatusSelecionado === substatus"
      }]
    }, [_c('div', {
      staticClass: "graph-legend"
    }, [_c('div', {
      staticClass: "legend",
      domProps: {
        "innerHTML": _vm._s(_vm.legendChart[substatus.toLowerCase()])
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "graph-container"
    }, [_c('PieChart', {
      attrs: {
        "chartdata": _vm.dataChart.substatus[substatus]
      },
      on: {
        "generated": function($event) {
          _vm.setLegend($event, substatus.toLowerCase())
        }
      }
    })], 1)]) : _vm._e()
  })], 2), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataLoaded) ? _c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": _vm.gerandoPdf
    },
    nativeOn: {
      "click": function($event) {
        _vm.printGraph('printSubstatus', 'Sub-status (' + _vm.substatusSelecionado + ')')
      }
    }
  }, [_vm._v("Baixar relatório")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "equal-heights px-5 pb-5 comparativo-row",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "comparativo-col",
    attrs: {
      "xs12": "",
      "md6": "",
      "id": "printProprietario"
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3 mr-4",
    staticStyle: {
      "min-height": "542px"
    },
    attrs: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "comparativo-titulo"
  }, [_c('strong', [_vm._v("Proprietário")])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative",
      "height": "calc(100% - 52px)"
    }
  }, [_c('div', {
    staticClass: "print-title"
  }, [_c('strong', [_vm._v("Proprietário")]), _vm._v(" "), _c('small', [_vm._v("Relatório gerado em " + _vm._s(_vm.data))])]), _vm._v(" "), _c('div', {
    staticClass: "graph-legend"
  }, [_c('div', {
    staticClass: "legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legendChart.proprietario)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "graph-container"
  }, [(_vm.dataLoaded) ? _c('PieChart', {
    attrs: {
      "chartdata": _vm.dataChart.proprietario
    },
    on: {
      "generated": function($event) {
        _vm.setLegend($event, 'proprietario')
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataLoaded) ? _c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": _vm.gerandoPdf
    },
    nativeOn: {
      "click": function($event) {
        _vm.printGraph('printProprietario', 'Proprietário')
      }
    }
  }, [_vm._v("Baixar relatório")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "comparativo-col",
    attrs: {
      "xs12": "",
      "md6": "",
      "id": "printVistoria"
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3 ml-4"
  }, [_c('div', {
    staticClass: "comparativo-titulo"
  }, [_c('strong', [_vm._v("Vistoria")])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative",
      "height": "calc(100% - 52px)"
    }
  }, [_c('div', {
    staticClass: "print-title"
  }, [_c('strong', [_vm._v("Vistoria")]), _vm._v(" "), _c('small', [_vm._v("Relatório gerado em " + _vm._s(_vm.data))])]), _vm._v(" "), _c('div', {
    staticClass: "graph-legend"
  }, [_c('div', {
    staticClass: "legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legendChart.vistoria)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "graph-container"
  }, [(_vm.dataLoaded) ? _c('PieChart', {
    attrs: {
      "chartdata": _vm.dataChart.vistoria
    },
    on: {
      "generated": function($event) {
        _vm.setLegend($event, 'vistoria')
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataLoaded) ? _c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": _vm.gerandoPdf
    },
    nativeOn: {
      "click": function($event) {
        _vm.printGraph('printVistoria', 'Vistoria')
      }
    }
  }, [_vm._v("Baixar relatório")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "equal-heights px-5 pb-5 comparativo-row",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "comparativo-col",
    attrs: {
      "xs12": "",
      "md6": "",
      "id": "printTipo"
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3 mr-4"
  }, [_c('div', {
    staticClass: "comparativo-titulo"
  }, [_c('strong', [_vm._v("Tipo")])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative",
      "height": "calc(100% - 52px)"
    }
  }, [_c('div', {
    staticClass: "print-title"
  }, [_c('strong', [_vm._v("Tipo")]), _vm._v(" "), _c('small', [_vm._v("Relatório gerado em " + _vm._s(_vm.data))])]), _vm._v(" "), _c('div', {
    staticClass: "graph-legend"
  }, [_c('div', {
    staticClass: "legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legendChart.tipo)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "graph-container"
  }, [(_vm.dataLoaded) ? _c('PieChart', {
    attrs: {
      "chartdata": _vm.dataChart.tipo
    },
    on: {
      "generated": function($event) {
        _vm.setLegend($event, 'tipo')
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataLoaded) ? _c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": _vm.gerandoPdf
    },
    nativeOn: {
      "click": function($event) {
        _vm.printGraph('printTipo', 'Tipo')
      }
    }
  }, [_vm._v("Baixar relatório")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "comparativo-col",
    attrs: {
      "xs12": "",
      "md6": "",
      "id": "printTarefas"
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3 ml-4"
  }, [_c('div', {
    staticClass: "comparativo-titulo"
  }, [_c('strong', [_vm._v("Tarefas")])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative",
      "height": "calc(100% - 52px)"
    }
  }, [_c('div', {
    staticClass: "print-title"
  }, [_c('strong', [_vm._v("Tarefas")]), _vm._v(" "), _c('small', [_vm._v("Relatório gerado em " + _vm._s(_vm.data))])]), _vm._v(" "), _c('div', {
    staticClass: "graph-legend"
  }, [_c('div', {
    staticClass: "legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legendChart.tarefas)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "graph-container"
  }, [(_vm.dataLoaded) ? _c('PieChart', {
    attrs: {
      "chartdata": _vm.dataChart.tarefas
    },
    on: {
      "generated": function($event) {
        _vm.setLegend($event, 'tarefas')
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataLoaded) ? _c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": _vm.gerandoPdf
    },
    nativeOn: {
      "click": function($event) {
        _vm.printGraph('printTarefas', 'Tarefas')
      }
    }
  }, [_vm._v("Baixar relatório")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "equal-heights px-5 pb-5 comparativo-row",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "comparativo-col",
    attrs: {
      "xs12": "",
      "md6": "",
      "id": "printIptu"
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3 mr-4",
    staticStyle: {
      "min-height": "542px"
    },
    attrs: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "comparativo-titulo"
  }, [_c('strong', [_vm._v("IPTU")])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative",
      "height": "calc(100% - 52px)"
    }
  }, [_c('div', {
    staticClass: "print-title"
  }, [_c('strong', [_vm._v("IPTU")]), _vm._v(" "), _c('small', [_vm._v("Relatório gerado em " + _vm._s(_vm.data))])]), _vm._v(" "), _c('div', {
    staticClass: "graph-legend"
  }, [_c('div', {
    staticClass: "legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legendChart.iptu)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "graph-container"
  }, [(_vm.dataLoaded) ? _c('PieChart', {
    attrs: {
      "chartdata": _vm.dataChart.iptu
    },
    on: {
      "generated": function($event) {
        _vm.setLegend($event, 'iptu')
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataLoaded) ? _c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": _vm.gerandoPdf
    },
    nativeOn: {
      "click": function($event) {
        _vm.printGraph('printIptu', 'IPTU')
      }
    }
  }, [_vm._v("Baixar relatório")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "comparativo-col",
    attrs: {
      "xs12": "",
      "md6": "",
      "id": "printCidade"
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3 ml-4"
  }, [_c('div', {
    staticClass: "comparativo-titulo"
  }, [_c('strong', [_vm._v("Cidade")])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative",
      "height": "calc(100% - 52px)"
    }
  }, [_c('div', {
    staticClass: "print-title"
  }, [_c('strong', [_vm._v("Cidade")]), _vm._v(" "), _c('small', [_vm._v("Relatório gerado em " + _vm._s(_vm.data))])]), _vm._v(" "), _c('table', _vm._l((this.comparativo.cidade), function(total, cidade) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(cidade))]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(total))]), _vm._v("   " + _vm._s(Math.floor(((total / _vm.totalCidades) * 100) + 0.5)) + "%")])])
  }))]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataLoaded) ? _c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": _vm.gerandoPdf
    },
    nativeOn: {
      "click": function($event) {
        _vm.printGraph('printCidade', 'Cidade')
      }
    }
  }, [_vm._v("Baixar relatório")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-476309f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Relatorios/RelatoriosComparativos.vue
// module id = 1015
// module chunks = 1